import * as React from 'react';

const SvgIconOenophile = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={25} fill="none" {...props}>
    <path
      d="M9 23.32h6M12 23.32v-8.341"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M18.887 7.256c.379 2.366-.588 4.745-2.534 6.24v0c-2.545 1.955-6.161 1.955-8.706 0v0c-1.946-1.495-2.913-3.874-2.534-6.24L5.9 2.331a.741.741 0 01.743-.611h10.714c.37 0 .685.26.741.61l.789 4.926z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.081 7.48h13.838"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconOenophile;
